<div class="maintenance-page">
  <div class="maintenance-card">
    <img
      src="assets/img/Logo-Renova2.png"
      alt="R-Inspection"
      class="maintenance-logo"
    />

    <ng-container *ngIf="!isBack; else backTemplate">
      <h1 class="maintenance-title">Sistema em manutenção</h1>

      <p class="maintenance-message" *ngIf="state?.message">
        {{ state.message }}
      </p>

      <div class="maintenance-time" *ngIf="state?.endsAt">
        <span class="maintenance-countdown">{{ countdown }}</span>
        <span class="maintenance-absolute">Previsão de retorno: {{ absoluteTime }}</span>
      </div>

      <a
        class="maintenance-notes-link"
        *ngIf="state?.releaseNotesUrl"
        [href]="state.releaseNotesUrl"
        target="_blank"
        rel="noopener"
      >
        Ver notas da versão
      </a>

      <div class="maintenance-status">
        <span class="maintenance-pulse"></span>
        Verificando disponibilidade...
      </div>

      <button class="maintenance-retry-btn" (click)="reload()">
        Tentar novamente
      </button>
    </ng-container>

    <ng-template #backTemplate>
      <ng-container *ngIf="state?.phase === 'normal'; else partialBackTemplate">
        <h1 class="maintenance-title maintenance-back">Estamos de volta!</h1>
        <p class="maintenance-message">Redirecionando para o login...</p>
      </ng-container>
      <ng-template #partialBackTemplate>
        <h1 class="maintenance-title maintenance-back">Sistema disponível</h1>
        <p class="maintenance-message">Manutenção ainda prevista. Redirecionando...</p>
      </ng-template>
    </ng-template>
  </div>
</div>
